export default __webpack_public_path__ + "static/media/image1.89e731ec.jpg";